import React from 'react';

import Separator from '../../components/Separator';
import heroImage from '../../assets/images/hero3.png';
import about from '../../assets/images/sobre.jpeg';
import {
  Container,
  Header,
  Image,
  Container2,
  Hero,
  HeroHeader,
  HeroImage,
  HeroLeft,
  HeroPathDown,
  HeroPathUp,
  HeroRight,
  HeroSeparator,
  Text,
  Text2,
} from './styles';

const Home = () => {
  return (
    <>
      <Container>
        <Hero>
          <HeroLeft>
            <HeroImage src={heroImage} alt="Logo" />
          </HeroLeft>
          <HeroRight>
            <Text>
              <HeroHeader>
                O maior e melhor buffet de sorvetes que você vai conhecer.
              </HeroHeader>
            </Text>
          </HeroRight>
        </Hero>
      </Container>
      <HeroSeparator
        id=""
        preserveAspectRatio="xMidYMax meet"
        className="svg-separator sep3"
        viewBox="0 0 1600 100"
        data-height="100"
      >
        <HeroPathUp d="M-40,83.627C20.307,83.627,20.058,44,80,44s60.003,40,120,40s59.948-40,120-40s60.313,40,120,40s60.258-40,120-40s60.202,40,120,40s60.147-40,120-40s60.513,40,120,40s60.036-40,120-40c59.964,0,60.402,40,120,40s59.925-40,120-40s60.291,40,120,40s60.235-40,120-40s60.18,40,120,40s59.82,0,59.82,0l0.18,14H-60V84L-40,83.627z"></HeroPathUp>
        <HeroPathDown d="M-40,95.627C20.307,95.627,20.058,56,80,56s60.003,40,120,40s59.948-40,120-40s60.313,40,120,40s60.258-40,120-40s60.202,40,120,40s60.147-40,120-40s60.513,40,120,40s60.036-40,120-40c59.964,0,60.402,40,120,40s59.925-40,120-40s60.291,40,120,40s60.235-40,120-40s60.18,40,120,40s59.82,0,59.82,0l0.18,138H-60V96L-40,95.627z"></HeroPathDown>
      </HeroSeparator>
      <Container2>
        <Header> Sobre Nós </Header>
        <Hero>
          <HeroLeft>
            <Text2>
              <header>Um pouco da nossa história.</header>

              <p>
                Em atividade desde 1985, a Sorveteria Newaska vem marcando
                gerações na sua cidade natal, se consolidando como um dos
                maiores pontos de encontro e fazendo parte de muitas histórias.
                Tudo começou com o sonho do fundador e proprietário João Carlos
                Riva de ter o seu próprio negócio. Vindo de uma família de
                origem italiana e muito unida, seu João teve apoio de seu irmão
                mais velho para abrir sua primeira loja. No princípio, ele
                trabalhava na distribuição de picolés na fábrica do irmão. Assim
                pôde aprender muito sobre todos os aspectos da produção de
                sorvetes. Após abrir a primeira sorveteria, no centro da cidade
                de Cachoeirinha, João começou a produzir seu sorvete nos fundos
                da loja, vendendo casquinhas e as famosas taças tradicionais,
                que fazem sucesso até hoje.
              </p>
              <p>
                A paixão por sorvetes fez do seu João um homem sempre atento ao
                mercado, buscando novidades e testando novos sabores . Assim,
                inaugurou o primeiro buffet de sorvetes da região. O sucesso foi
                tremendo, a sorveteria despertou curiosidade e foi atraindo
                visitantes de várias cidades vizinhas. Em xxxx, João Carlos
                decidiu dar um passo adiante e criar sua marca de sorvetes:
                Gella Comelly. A empresa cresceu e a fábrica mudou-se de lugar.
                Hoje, os planos de expansão da Gella Comelly são a maior
                motivação da família toda, engajada na empresa junto com seu
                João. Atualmente, a Sorveteria Newaska conta com duas lojas em
                sua rede, a matriz em Cachoerinha e a filial na Morada do Vale I
                em Gravataí. Com mais de 40 sabores, as lojas oferecem um
                diferenciado buffet de sorvetes e um cardápio que vai de taças
                tradicionais e especiais, além de diversas opções de potes e
                picolés para levar para casa. A última novidade incluída no
                cardápio é o açaí da marca Gella Comelly, que segue o alto
                padrão de qualidade dos sorvetes e vem batendo recordes de
                venda.
              </p>
            </Text2>
          </HeroLeft>
          <HeroRight>
            <Image src={about} alt="Logo" />
          </HeroRight>
        </Hero>
      </Container2>
      <Separator bgColor="#a4bbda" />
    </>
  );
};

export default Home;
